"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLayout = void 0;
var React = require("react");
var BaseLayout = /** @class */ (function (_super) {
    __extends(BaseLayout, _super);
    function BaseLayout(props) {
        var _this = _super.call(this, props) || this;
        _this.index = 0;
        _this.state = Object.assign(_this.state || {}, {
            widgets: _this.props.widgets.slice(0)
        });
        return _this;
    }
    BaseLayout.prototype.render = function () {
        this.index = 0;
        return this.renderLayout();
    };
    BaseLayout.prototype.renderWidget = function (widget) {
        return (React.createElement("div", { id: widget.widget.id, className: "widget", key: widget.widget.id }, React.createElement(widget.widget.component, widget.props)));
    };
    BaseLayout.prototype.pull = function (count) {
        var _this = this;
        if (count === void 0) { count = 1; }
        var widgets = [];
        for (var a = 0; a < count; a++) {
            if (this.index < this.state.widgets.length) {
                widgets.push(this.state.widgets[this.index]);
                this.index++;
            }
            else {
                break;
            }
        }
        return widgets.map(function (x) { return _this.renderWidget(x); });
    };
    BaseLayout.prototype.pullRest = function () {
        var _this = this;
        var widgets = [];
        while (this.index < this.state.widgets.length) {
            widgets.push(this.state.widgets[this.index]);
            this.index++;
        }
        return widgets.map(function (x) { return _this.renderWidget(x); });
    };
    return BaseLayout;
}(React.Component));
exports.BaseLayout = BaseLayout;
//# sourceMappingURL=BaseLayout.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/widgets/layouts/BaseLayout.js
// module id = 632
// module chunks = 0